import { render, staticRenderFns } from "./Takings.vue?vue&type=template&id=c1dd5766&"
import script from "./Takings.vue?vue&type=script&lang=js&"
export * from "./Takings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports